import React from 'react';

import { XIcon } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/shadcn/ui/drawer';
import { ScrollArea } from '@/components/shadcn/ui/scroll-area';
import { useHeaderWalletDrawerStore } from '@/shared';

import HeaderWalletButton from './HeaderWalletButton';
import HeaderWalletDrawerBalances from './HeaderWalletDrawerBalances';
import HeaderWalletDrawerWallets from './HeaderWalletDrawerWallets';

interface HeaderWalletDrawerProps {}

const HeaderWalletDrawer: React.FC<HeaderWalletDrawerProps> = () => {
  const isDrawerOpen = useHeaderWalletDrawerStore((state) => state.isDrawerOpen);
  const setIsDrawerOpen = useHeaderWalletDrawerStore((state) => state.setIsDrawerOpen);

  return (
    <Drawer direction="right" open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerTrigger asChild>
        <HeaderWalletButton />
      </DrawerTrigger>

      <DrawerContent className="flex w-[calc(100vw-16px)] max-w-96 flex-col gap-5 p-3">
        <DrawerTitle hidden>Wallets Info</DrawerTitle>

        <DrawerClose className="mt-2 flex w-full justify-end md:hidden" asChild>
          <div>
            <Button variant="secondary" className="rounded-full">
              <XIcon />
            </Button>
          </div>
        </DrawerClose>

        <DrawerDescription asChild>
          <ScrollArea>
            <div className="flex flex-col gap-4">
              <HeaderWalletDrawerWallets />
              <hr className="border-background mx-auto w-32" />
              <HeaderWalletDrawerBalances />
            </div>
          </ScrollArea>
        </DrawerDescription>
      </DrawerContent>
    </Drawer>
  );
};

export default HeaderWalletDrawer;
